<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="auth-wrapper d-flex align-center justify-center pa-2 pa-md-0">
    <v-card class="auth-card pa-2 pa-md-0 d-flex">
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-row class="pa-2 pa-md-5">
            <v-col cols="12">
              <RouterLink
                to="/"
                class="d-flex align-center gap-3"
              >
                <Logo />
              </RouterLink>
            </v-col>
            <v-col
              cols="12"
              class="pa-0"
              style="max-width: 600px;"
            >
              <slot />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="d-none d-md-flex pa-0 meta-visual"
        >
          <v-img
            :src="randomVisual"
            lazy-src="/images/register/register-visual1.jpg"
            alt="TerminTiger Registration Visual"
            cover
            height="100%"
            width="100"
            aspect-ratio="9/16"
            class="rounded-e-lg"
          />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script setup lang="ts">

const registerVisuals = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10
];

const randomVisual = computed(() => {
  return "/images/register/register-visual" + registerVisuals[Math.floor(Math.random() * registerVisuals.length)] + ".jpg";
});

const showVisual = true;
</script>